/* =====================================================================
 * Result Calculation
 * ===================================================================*/

import helpers from '../helpers.js';

export default {
  inputCalc: {
    sb: (k, ca, mg) => {
      return helpers.numberFix(k + ca + mg);
    },

    ctc: (k, ca, mg, hal) => {
      return helpers.numberFix(k + ca + mg + hal);
    },

    vone: (k, ca, mg, ctc) => {
      return helpers.numberFix(((k + ca + mg) / ctc) * 100);
    }
  },

  basePosition: {
    ctcCalcio: (ca, ctc) => {
      return helpers.numberFix((ca / ctc) * 100);
    },

    teorCalcio: (ctcCalcio) => {
      if (ctcCalcio < 40) {
        return 'Deficiente';
      }

      if (ctcCalcio < 50) {
        return 'Médio';
      }

      if (ctcCalcio < 60) {
        return 'Equilibrado';
      }

      if (ctcCalcio >= 60) {
        return 'Alto';
      }
    },

    ctcMagnesio: (mg, ctc) => {
      return helpers.numberFix((mg / ctc) * 100);
    },

    teorMagnesio: (ctcMagnesio) => {
      if (ctcMagnesio < 7) {
        return 'Deficiente';
      }

      if (ctcMagnesio < 12) {
        return 'Médio';
      }

      if (ctcMagnesio < 20) {
        return 'Equilibrado';
      }

      if (ctcMagnesio >= 20) {
        return 'Alto';
      }
    },

    camg: (ca, mg) => {
      return helpers.numberFix(ca / mg);
    }
  },

  corrective: {
    dose: (vone, vtwo, measure, ctc, prnt) => {
      if (vtwo <= vone) {
        return 'Não';
      }

      if (measure == 'Ton/ha') {
        return helpers.numberFix(((vtwo - vone) * ctc) / (prnt * 10), 2);
      }

      return helpers.numberFix((((vtwo - vone) * ctc) / (prnt * 10)) * 2.42, 2);
    },
  },

  estimatedPosition: {
    mmolCalcio: (dose, measure, ajuste, cao, prnt, ca) => {
      if (dose === 'Não') {
        return ca;
      }

      const value = ajuste ? ajuste : dose;

      if (measure === 'Ton/ha') {
        return helpers.numberFix((((value * cao * 0.00017875 * prnt) * 10) + Number(ca)));
      }

      return helpers.numberFix(((((value / 2.42) * cao * 0.00017875 * prnt) * 10) + Number(ca)));
    },

    ctcCalcio: (dose, mmolCalcio, ctc, calculatedCTC) => {
      if (dose === 'Não') {
        return calculatedCTC;
      }

      return helpers.numberFix((mmolCalcio / ctc) * 100);
    },

    teorCalcio: (ctcCalcio) => {
      if (ctcCalcio < 40) {
        return 'Deficiente';
      }

      if (ctcCalcio < 50) {
        return 'Médio';
      }

      if (ctcCalcio < 60) {
        return 'Equilibrado';
      }

      if (ctcCalcio >= 60) {
        return 'Alto';
      }
    },

    mmolMagnesio: (dose, measure, ajuste, mgo, prnt, mg) => {
      if (dose === 'Não') {
        return mg;
      }

      const value = ajuste ? ajuste : dose;

      if (measure === 'Ton/ha') {
        return helpers.numberFix(((value * mgo * 0.00024774 * prnt) * 10) + Number(mg));
      }

      return helpers.numberFix((((value / 2.42) * mgo * 0.00024774 * prnt) * 10) + Number(mg));
    },

    ctcMagnesio: (dose, mmolMagnesio, ctc, calculatedCTC) => {
      if (dose === 'Não') {
        return calculatedCTC;
      }

      return helpers.numberFix((mmolMagnesio / ctc) * 100, 2);
    },

    teorMagnesio: (ctcMagnesio) => {
      if (ctcMagnesio < 7) {
        return 'Deficiente';
      }

      if (ctcMagnesio < 12) {
        return 'Médio';
      }

      if (ctcMagnesio < 20) {
        return 'Equilibrado';
      }

      if (ctcMagnesio >= 20) {
        return 'Alto';
      }
    },

    camg: (dose, ca, mg, ctcCalcio, ctcMagnesio) => {
      if (dose === 'Não') {
        return helpers.numberFix(ca / mg);
      }

      return helpers.numberFix(ctcCalcio / ctcMagnesio);
    },

    vtwo: (dose, ajuste, measure, vone, vtwo, prnt, ctc) => {
      if (dose === 'Não') {
        return '';
      }

      if (!ajuste) return vtwo;

      if (measure === 'Ton/ha') {
        return helpers.numberFix(((prnt * 10 * ajuste) / ctc) + Number(vone));
      }

      return helpers.numberFix((prnt * 10 * (ajuste / 2.42) / ctc) + Number(vone));
    },
  },
};
